export const CONSTRUCTOR_URL = 'https://configurator.woodandwashi.ru';
export const LIBRARY_URL = 'https://library.woodandwashi.ru';
export const API_URL = 'https://api.woodandwashi.ru/api';

export const dutchedVersion = false;

export const collections = [
  {
    value: 'Elegance',
    name: 'Elegance',
    combi: ['flow']
  },
  {
    value: 'Excellence',
    name: 'Excellence',
    combi: ['rollo', 'flow', 'banner', 'panel']
  },
  {
    value: 'Exquisite',
    name: 'Exquisite',
    combi: ['rollo', 'flow', 'banner', 'panel']
  },
  {
    value: 'Style',
    name: 'Style'
  },
  {
    value: 'Select',
    name: 'Select'
  },
  {
    value: 'Superb',
    name: 'Superb',
    combi: ['rollo', 'flow', 'banner', 'panel']
  }
];
